import { AppState } from '~/providers'
import type { IGeolocation } from '~/types/geolocation'

export const useGeolocation = () => {
  const { ssrContext } = useNuxtApp()

  return useState<IGeolocation>(AppState.Geolocation, () => ssrContext?.event.context.geolocation).value
}
